import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
export function loadGltfCustom(url) {
    return new Promise((resolve, reject) => {
        // Instantiate GLTFLoader
        const loader = new GLTFLoader();

        // Load a GLTF model
        loader.load(
            // URL of the model
            url,
            // onLoad callback
            function (gltf) {
                resolve(gltf);
            },
            function (xhr) {
                let percentLoaded = (xhr.loaded / xhr.total) * 100 + "% loaded";
            },
            function (error) {
                console.error("An error happened", error);
                reject(error);
            }
        );
    })

}